import React from "react";
import { motion } from "framer-motion";

// Editorial pull-quote block that sits between the stats strip and the
// discography. Big serif-ish display type for a magazine moment.
export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-3 flex flex-col gap-2"
          >
            <span className="font-display text-[#C5A059] text-lg md:text-xl tracking-tight">
              Manifesto
            </span>
            <span className="h-px w-16 bg-[#C5A059]/40" />
            <span className="text-[10px] uppercase tracking-[0.4em] text-[#F5F5F0]/50">
              A note from Bob
            </span>
          </motion.div>

          <div className="lg:col-span-9">
            <motion.blockquote
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#F5F5F0]"
            >
              <span className="text-[#C5A059] font-semibold">&ldquo;</span>
              Every song is a chapter.{" "}
              <span className="text-[#F5F5F0]/60">
                Heartbreak, late nights, the parts of love nobody frames —
              </span>{" "}
              I write it <span className="b9-badge">gold</span> so it lasts.
              <span className="text-[#C5A059] font-semibold">&rdquo;</span>
            </motion.blockquote>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: 0.3 }}
              className="mt-10 flex items-center gap-4"
            >
              <span className="h-px w-14 bg-[#C5A059]" />
              <div>
                <div className="font-display text-base text-[#F5F5F0]">
                  Bobby Pemberton
                </div>
                <div className="text-[10px] uppercase tracking-[0.35em] text-[#F5F5F0]/40 mt-1">
                  a.k.a. Bob9ine
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
